import type { ReactNode } from "react";
import { highlightText } from "./EntryCard";
import type { DictionaryEntry, VisibleFields } from "../types";

type EntriesTableProps = {
  entries: DictionaryEntry[];
  query: string;
  visibleFields: VisibleFields;
};

export function EntriesTable({ entries, query, visibleFields }: EntriesTableProps) {
  const columns: Array<{
    key: string;
    label: string;
    include: boolean;
    render: (entry: DictionaryEntry) => ReactNode;
  }> = [
    { key: "rank", label: "Rank", include: true, render: (entry) => `#${entry.rank}` },
    { key: "term", label: "Korean", include: true, render: (entry) => highlightText(entry.term, query) },
    { key: "eng", label: "English", include: visibleFields.english, render: (entry) => highlightText(entry.eng ?? "", query) },
    { key: "def", label: "Definition", include: visibleFields.definition, render: (entry) => highlightText(entry.def ?? "", query) },
    { key: "pos", label: "POS", include: visibleFields.pos, render: (entry) => entry.pos }
  ];

  const activeColumns = columns.filter((col) => col.include);

  return (
    <div className="table-wrapper">
      <table className="entries-table">
        <thead>
          <tr>
            {activeColumns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {entries.map((entry) => (
            <tr key={entry.rank}>
              {activeColumns.map((col) => (
                <td key={col.key}>{col.render(entry)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
